<template>
  <div class="userLogin">
    <div class="userLogin-content">
      <h1>闽江航道数据管理平台</h1>
      <el-form
        ref="ruleFormRef"
        :model="loginForm"
        :rules="rules"
        label-width="auto"
        label-position="top"
        status-icon
        size="large"
      >
        <el-form-item label="登录账号" prop="username">
          <el-input
            @keydown.enter="submitForm(ruleFormRef)"
            :prefix-icon="User"
            placeholder="登录账号"
            v-model="loginForm.username"
          />
        </el-form-item>

        <el-form-item label="登录密码" prop="password">
          <el-input
            show-password
            :prefix-icon="Lock"
            @keydown.enter="submitForm(ruleFormRef)"
            type="password"
            placeholder="登录密码"
            v-model="loginForm.password"
          />
        </el-form-item>

        <el-form-item label="验证码" class="userLogin-content-captcha" prop="code">
          <el-input
            @keydown.enter="submitForm(ruleFormRef)"
            :prefix-icon="Key"
            placeholder="验证码"
            v-model="loginForm.code"
          />
          <img @click="refreshCaptcha" :src="captchaImg" alt="" />
        </el-form-item>

        <el-form-item>
          <el-button :loading="loading" type="primary" @click="submitForm(ruleFormRef)">
            登 录
          </el-button>
        </el-form-item>
      </el-form>
    </div>
  </div>
</template>

<script lang="ts" setup>
import { ElMessage, type FormInstance } from 'element-plus'
import { User, Lock, Key } from '@element-plus/icons-vue'
import type { IUserLoginParams } from '@/apiFzn/types'
import { getCaptchaImage, userLogin } from '@/apiFzn'
import { useUserStore } from '@/stores/user'
import { ref, shallowRef } from 'vue'
import { useRouter } from 'vue-router'
import { setToken } from '@/utils/auth'
const router = useRouter()
const userStore = useUserStore()

const loading = ref(false)

// Form表单实例
const ruleFormRef = shallowRef()

// Form表单参数
const loginForm = ref<IUserLoginParams>({
  username: '',
  password: '',
  uuid: '',
  code: '',
})

const captchaImg = ref()

// Form表单规则校验
const rules = ref({
  username: [{ required: true, message: '请输入用户名', trigger: 'blur' }],
  password: [
    { required: true, message: '请输入密码', trigger: 'blur' },
    { min: 6, max: 20, message: '长度在 6 到 20 个字符', trigger: 'blur' },
  ],
  code: [{ required: true, message: '请输入验证码', trigger: 'blur' }],
})

/** 刷新验证码 */
const refreshCaptcha = () => {
  getCaptchaImage().then((res) => {
    captchaImg.value = 'data:image/gif;base64,' + res.img
    loginForm.value.uuid = res.uuid
  })
}

refreshCaptcha()

/**
 * 表单提交事件
 * @param formEl Form表单实例
 */
const submitForm = async (formEl: FormInstance | undefined) => {
  if (!formEl) return
  await formEl.validate((valid) => {
    if (valid) {
      loading.value = true
      userLogin(loginForm.value)
        .then((res) => {
          {
            // 已经授权的用户进入系统
            setToken(res.token as string)
            userStore.getUserInfoHandler()
            ElMessage.success('登录成功！')
            router.push('/home')
          }
        })
        .catch(refreshCaptcha)
        .finally(() => {
          loading.value = false
        })
    }
  })
}
</script>

<style lang="scss" scoped>
.userLogin {
  height: 100vh;
  background: url('../assets/login_page_v1.png') no-repeat;
  background-size: cover;

  &-content {
    background-color: #fff;
    border-radius: 16px;
    overflow: hidden;
    width: 480px;
    position: fixed;
    top: 50%;
    right: 12%;
    transform: translateY(-50%);
    padding: 36px;
    box-sizing: border-box;
    box-shadow: 0px 12px 25px  rgba(48, 176, 227, 0.15);
    > h1 {
      font-size: 30px;
      font-weight: 600;
      color: #333;
      margin-bottom: 28px;
    }
    &::before {
      content: '';
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: 10px;
      background-color: #1484ff;
    }

    .el-form {
      :deep(.el-form-item) {
        margin-bottom: 24px;

        .el-form-item__label {
          font-size: 16px;
        }
      }
    }

    &-captcha {
      .el-input {
        width: 65%;
        margin-right: 14px;
      }

      img {
        width: calc(100% - 65% - 14px);
        height: 40px;
        cursor: pointer;
      }
    }

    .el-button {
      width: 100%;
      font-size: 16px;
      margin-top: 28px;
    }
  }
}
</style>
